import * as React from "react"

const FilePreview = ({ blob, style }) => {
  return <img src={blob} width="100%" style={style} />
}

export default FilePreview
